import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteItinerarySearchOmission } from '../../../../actions/itinerary';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteItinerarySearchOmissionButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { itinerarySearchOmissionId, dispatchDeleteItinerarySearchOmission } =
      this.props;
    dispatchDeleteItinerarySearchOmission({ itinerarySearchOmissionId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );
    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteItinerarySearchOmissionButton.propTypes = {
  itinerarySearchOmissionId: PropTypes.number.isRequired,
  dispatchDeleteItinerarySearchOmission: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteItinerarySearchOmission: deleteItinerarySearchOmission,
};

export default connect(
  null,
  mapDispatchToProps,
)(DeleteItinerarySearchOmissionButton);
